import {
  DISTRIBUTION_CHANNEL_HEADER,
  JSON_LONG_AS_STRING_HEADER,
  LANGUAGE_HEADER,
  SESSION_ID_HEADER,
  SYSTEM_ID_HEADER
} from './api.constants';

export const LANGUAGE_URL_PARAM = 'Language';
export const JSON_LONG_AS_STRING_PARAM = 'JsonLongAsString/true';
export const RESTRICTED_HEADERS_FOR_METADATA = [
  DISTRIBUTION_CHANNEL_HEADER,
  JSON_LONG_AS_STRING_HEADER,
  LANGUAGE_HEADER,
  SESSION_ID_HEADER,
  SYSTEM_ID_HEADER
];
export const SYSTEM_ID_URL_PARAM = 'SystemId';
